import type React from 'react';
import type { Props } from './interface';
import { useQuery } from '@tanstack/react-query';
import { contentQueries } from 'services/content/contentQueries';
import { ContentType } from 'utils/getContentType';
import { useDocumentExpirationLabel } from './useDocumentExpirationLabel';
import { useExpiryDateCalendar } from '../../editor/EditorMenu/ShareV3/useExpiryDateCalendar';
import { useDocumentExpiryDate } from '../../../hooks/useDocumentExpiryDate.ts';
import dayjs from 'dayjs';
import ExpiryBanner from '../../ExpiryBanner/ExpiryBanner';

const Banner: React.FC<Props> = ({ contentId }) => {
  const { getDocumentExpiryDate, isDocumentExpired } = useDocumentExpiryDate({ contentId });
  const { data: documentData } = useQuery(contentQueries.publicContentMetadataById(ContentType.DOCUMENT, contentId));
  const currentExpiryAtDate = dayjs(getDocumentExpiryDate.data?.expire_at);
  const { open: openCalendar, modal } = useExpiryDateCalendar({ contentId, currentExpiryAtDate });
  const { hasExpirationDate, formattedDate } = useDocumentExpirationLabel({ expiryDate: currentExpiryAtDate });

  const isOwner = documentData?.isDocumentBelongsToSameAccount ?? false;
  const isExpired = isDocumentExpired().isExpired === true;

  return (
    <ExpiryBanner
      isLocked={documentData?.isLocked ?? false}
      isExpired={isExpired}
      isOwner={isOwner}
      hasExpirationDate={hasExpirationDate}
      formattedDate={formattedDate}
      openCalendar={openCalendar}
      modal={modal}
    />
  );
};

export default Banner;
